import React, { useState, useEffect } from 'react';
import { fromZonedTime, formatInTimeZone } from 'date-fns-tz';
import './_Modal.css';
const NewsModal = ({ isOpen, onClose, onSave, newsItem }) => {
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [priority, setPriority] = useState(3);
    const [publishAt, setPublishAt] = useState('');
    const [expiresAt, setExpiresAt] = useState('');

    useEffect(() => {
        const timezone = localStorage.getItem('timezone') || 'UTC';
        if (newsItem) {
            setTitle(newsItem.title);
            setText(newsItem.text);
            setPriority(newsItem.priority.id);
            if (newsItem.publish_at) {
                setPublishAt(formatInTimeZone(new Date(newsItem.publish_at), timezone, "yyyy-MM-dd'T'HH:mm"));
            }
            setExpiresAt(formatInTimeZone(new Date(newsItem.expires_at), timezone, "yyyy-MM-dd'T'HH:mm"));
        } else {
            setTitle('');
            setText('');
            setPriority(3);
            setPublishAt('');
            setExpiresAt('');
        }
    }, [newsItem]);

    if (!isOpen) {
        return null;
    }

    const handleSave = () => {
        if (!title || !text || !expiresAt) {
            alert('Please fill all required fields');
            return;
        }

        const timezone = localStorage.getItem('timezone') || 'UTC';

        const newsData = {
            title,
            text,
            priority: parseInt(priority, 10),
            publish_at: publishAt ? fromZonedTime(publishAt, timezone).toISOString() : null,
            expires_at: fromZonedTime(expiresAt, timezone).toISOString(),
        };
        onSave(newsData);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{newsItem ? 'Edit News' : 'Create News'}</h2>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <textarea
                        placeholder="Text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    ></textarea>
                </div>
                <div className="form-group">
                    <label>Priority</label>
                    <select value={priority} onChange={(e) => setPriority(e.target.value)}>
                        <option value="1">High</option>
                        <option value="2">Medium</option>
                        <option value="3">Low</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Publish At</label>
                    <input
                        type="datetime-local"
                        placeholder="Publish At"
                        value={publishAt}
                        onChange={(e) => setPublishAt(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Expires At</label>
                    <input
                        type="datetime-local"
                        placeholder="Expires At"
                        value={expiresAt}
                        onChange={(e) => setExpiresAt(e.target.value)}
                    />
                </div>
                <div className="actions-centered">
                    <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                    <button type="submit" onClick={handleSave} className="submit-button text-button">Save</button>
                </div>
            </div>
        </div>
    );
};

export default NewsModal;
